"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var mobx_react_1 = require("mobx-react");
var api_1 = __importStar(require("api"));
var config_1 = __importDefault(require("config"));
var use_stores_1 = require("hooks/use-stores");
var Modal_1 = __importDefault(require("components/modal/Modal"));
var use_dialog_1 = require("hooks/use-dialog");
var use_notification_1 = require("hooks/use-notification");
var Dialog_1 = require("../../../Dialog");
var ProductCategoryForm_1 = __importDefault(require("../ProductCategoryForm"));
var Notification_1 = require("../../../Notification");
var utils_1 = require("../../../../util/utils");
var edit_icon_svg_1 = __importDefault(require("res/img/edit-icon.svg"));
var apiRoutes = config_1.default.apiRoutes;
var EditProductCategory = mobx_react_1.observer(function () {
    var _a = react_1.useState({}), data = _a[0], setData = _a[1];
    var _b = react_1.useState(null), fileList = _b[0], setFileList = _b[1];
    var _c = react_1.useState(false), success = _c[0], setSuccess = _c[1];
    var _d = use_stores_1.useStores(), apiStore = _d.apiStore, productCategoriesStore = _d.productCategoriesStore;
    var busyRoutes = apiStore.data.busyRoutes;
    var dialog = use_dialog_1.useDialog();
    var notification = use_notification_1.useNotification();
    var history = react_router_dom_1.useHistory();
    var successTimerRef = react_1.useRef(null);
    var params = react_router_dom_1.useParams();
    react_1.useEffect(function () {
        if (productCategoriesStore.data.length <= 0 &&
            !busyRoutes.includes(apiRoutes.PRODUCT_CATEGORIES)) {
            api_1.default.getProductCategories()
                .then(function (response) { return productCategoriesStore.setData(response.data); })
                .catch(api_1.catchHandler);
        }
    }, []);
    react_1.useEffect(function () {
        for (var _i = 0, _a = productCategoriesStore.data; _i < _a.length; _i++) {
            var category = _a[_i];
            if (category.id === parseInt(params.id)) {
                setData(category);
            }
        }
    }, [params.id, productCategoriesStore.data.length]);
    var changeHandler = function (e) {
        var _a;
        setData(__assign(__assign({}, data), (_a = {}, _a[e.currentTarget.name] = e.currentTarget.value, _a)));
    };
    var getImageWidth = function (url) { return new Promise(function (resolve) {
        var img = new Image();
        img.onload = function () { return resolve(img.width); };
        img.src = url;
    }); };
    var fileChangeHandler = function (name, fileList) { return __awaiter(void 0, void 0, void 0, function () {
        var url, width;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = URL.createObjectURL(fileList[0]);
                    return [4 /*yield*/, getImageWidth(url)];
                case 1:
                    width = _a.sent();
                    URL.revokeObjectURL(url);
                    if (!(width < 1000)) return [3 /*break*/, 3];
                    return [4 /*yield*/, dialog({
                            variant: Dialog_1.DialogVariants.ALERT,
                            title: 'Image will not be uploaded',
                            description: "The chosen image is below 1000px and will not display well on higher definition screens. Please only upload images above 1000px, preferably above 2000px for optimal display."
                        })];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
                case 3:
                    if (width < 2000) {
                        dialog({
                            variant: Dialog_1.DialogVariants.CONFIRMATION,
                            title: 'Image is low quality',
                            description: "The chosen image is below 2000px wide. These images will not display well on larger screens or retina displays. Would you like to continue with this upload?",
                        })
                            .then(function () {
                            setFileList(fileList);
                        });
                        return [2 /*return*/];
                    }
                    setFileList(fileList);
                    return [2 /*return*/];
            }
        });
    }); };
    var changeDescriptionHandler = function (html) {
        var _a;
        setData(__assign(__assign({}, data), (_a = {}, _a['description'] = html, _a)));
    };
    var submitHandler = function () {
        if (!data.name || data.name.length <= 0) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: 'Please enter a name'
            });
            return;
        }
        clearTimeout(successTimerRef.current);
        var formData = new FormData();
        formData.append('name', data.name);
        data.description !== undefined ? formData.append('description', data.description) : null;
        data.pageHeading !== undefined ? formData.append('pageHeading', data.pageHeading) : null;
        data.metaTitle !== undefined ? formData.append('metaTitle', data.metaTitle) : null;
        data.metaDescription !== undefined ? formData.append('metaDescription', data.metaDescription) : null;
        if (fileList !== null) {
            formData.append('image', fileList[0]);
        }
        formData.append('_method', 'PATCH');
        api_1.default.editProductCategoryFD(data.id, formData)
            .then(function (response) {
            productCategoriesStore.editDataItem(response.data);
            setSuccess(true);
            successTimerRef.current = setTimeout(function () {
                setSuccess(false);
                history.replace('/products/categories');
            }, 1500);
        })
            .catch(api_1.catchHandler);
    };
    return (react_1.default.createElement(Modal_1.default, { title: [
            react_1.default.createElement("img", { key: "cpc_title_1", src: edit_icon_svg_1.default, alt: 'Edit Category' }),
            react_1.default.createElement("span", { key: "cpc_title_2" }, "Edit Product Category")
        ] },
        react_1.default.createElement("div", { className: 'create-product-category create-modal' }, data.id ?
            react_1.default.createElement(ProductCategoryForm_1.default, { data: data, files: fileList, onChange: changeHandler, onChangeFile: fileChangeHandler, onSubmit: submitHandler, onChangeDescription: changeDescriptionHandler, busy: busyRoutes.includes(apiRoutes.PRODUCT_CATEGORIES), success: success, formType: utils_1.FormTypes.EDIT }) : null)));
});
exports.default = EditProductCategory;
